import AppConstants from "../../../../../config/app.constants";

class BillingCategoryAllController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BillingCategoryService) {
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillingCategoryService = BillingCategoryService;

        this.model = {
            billingCategoryObj: {
                totalRecords: 0,
                categoryList: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            allowOnlyOnce: false,
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: '',
        }
    }

    $onInit() {
        this.loadData();
    }

    searchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    group: {
                        rules: [{
                            field: 'name',
                            condition: 'like',
                            data: '%' + this.model.searchText + '%'
                        }],
                        operator: 'OR'
                    }
                }],
                operator: 'AND'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    loadAllCategory() {
        this.model.billingCategoryObj.loading = true;

        this.BillingCategoryService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit)
            .then((data) => {
                this.model.billingCategoryObj.categoryList = data.results;
                this.model.billingCategoryObj.totalRecords = data.total;
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.billingCategoryObj.loading = false;
            })
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.model.pagination.page)
        this.$stateParams.page = this.model.pagination.page;
        this.$location.path(newUrl);
        this.loadAllCategory();
    }

    loadData() {
        this.model.pagination.page = 1;
        this.loadAllCategory();
    }

    search() {
        this.pageChange();
    }

    edit(billingCategory) {
        this.$state.go('billing_category.edit', ({
            id: billingCategory.id
        }))
    }
}
export default BillingCategoryAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/all/billing_category.all.controller.js